module.exports = {
    "breadcrumbs": `S\xf6kv\xe4gar`
};


//# sourceMappingURL=sv-SE.main.js.map
